var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeropeople(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 124,
    viewBox: "0 0 124 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4419_239075)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 36.6016,
    y: 36.9624,
    width: 50,
    height: 50,
    rx: 10,
    fill: "#36B696"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.1016,
    y: 38.4624,
    width: 47,
    height: 47,
    rx: 8.5,
    stroke: "black",
    strokeOpacity: 0.1,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.5514 58.5335C66.6554 58.5335 67.5514 59.4295 67.5514 60.5335V68.2466C67.5514 69.914 66.8891 71.5131 65.7101 72.6921C64.5311 73.8711 62.932 74.5335 61.2646 74.5335C59.5972 74.5335 57.9981 73.8711 56.8191 72.6921C55.6401 71.5131 54.9777 69.914 54.9777 68.2466V60.5335C54.9777 59.4295 55.8726 58.5335 56.9777 58.5335H65.5514ZM49.5469 58.5335L54.5549 58.5312C54.143 59.0274 53.8951 59.6391 53.8452 60.2821L53.8337 60.5335V68.2466C53.8337 69.5415 54.1663 70.7598 54.748 71.8203C53.9651 72.162 53.1094 72.3032 52.2581 72.2313C51.4069 72.1595 50.587 71.8768 49.8724 71.4087C49.1578 70.9407 48.571 70.302 48.165 69.5505C47.759 68.7989 47.5466 67.958 47.5469 67.1038V60.5335C47.5472 60.0029 47.7581 59.4942 48.1334 59.1192C48.5087 58.7442 49.0163 58.5335 49.5469 58.5335ZM67.9743 58.5312L72.9754 58.5335C74.0794 58.5335 74.9754 59.4295 74.9754 60.5335V67.1049C74.9758 67.9588 74.7635 68.7994 74.3578 69.5507C73.952 70.302 73.3656 70.9405 72.6514 71.4086C71.9371 71.8766 71.1176 72.1594 70.2668 72.2315C69.4159 72.3036 68.5605 72.1627 67.7777 71.8215L67.8417 71.7049C68.332 70.7758 68.6303 69.7289 68.6852 68.6192L68.6943 68.2466V60.5335C68.6943 59.7723 68.4234 59.0752 67.9743 58.5312ZM61.2612 49.3906C61.7864 49.3906 62.3066 49.4941 62.7919 49.6951C63.2772 49.8961 63.7182 50.1908 64.0896 50.5622C64.461 50.9336 64.7557 51.3746 64.9567 51.8599C65.1577 52.3452 65.2612 52.8653 65.2612 53.3906C65.2612 53.9159 65.1577 54.4361 64.9567 54.9214C64.7557 55.4067 64.461 55.8476 64.0896 56.2191C63.7182 56.5905 63.2772 56.8851 62.7919 57.0861C62.3066 57.2872 61.7864 57.3906 61.2612 57.3906C60.2003 57.3906 59.1829 56.9692 58.4327 56.2191C57.6826 55.4689 57.2612 54.4515 57.2612 53.3906C57.2612 52.3298 57.6826 51.3123 58.4327 50.5622C59.1829 49.8121 60.2003 49.3906 61.2612 49.3906ZM70.4074 50.5335C70.8577 50.5335 71.3035 50.6222 71.7195 50.7945C72.1355 50.9668 72.5134 51.2193 72.8318 51.5377C73.1502 51.8561 73.4027 52.234 73.575 52.65C73.7473 53.066 73.836 53.5118 73.836 53.9621C73.836 54.4123 73.7473 54.8581 73.575 55.2741C73.4027 55.6901 73.1502 56.068 72.8318 56.3864C72.5134 56.7048 72.1355 56.9573 71.7195 57.1296C71.3035 57.3019 70.8577 57.3906 70.4074 57.3906C69.4981 57.3906 68.6261 57.0294 67.9831 56.3864C67.3401 55.7434 66.9789 54.8714 66.9789 53.9621C66.9789 53.0527 67.3401 52.1807 67.9831 51.5377C68.6261 50.8947 69.4981 50.5335 70.4074 50.5335ZM52.1149 50.5335C52.5651 50.5335 53.011 50.6222 53.4269 50.7945C53.8429 50.9668 54.2209 51.2193 54.5392 51.5377C54.8576 51.8561 55.1102 52.234 55.2825 52.65C55.4548 53.066 55.5434 53.5118 55.5434 53.9621C55.5434 54.4123 55.4548 54.8581 55.2825 55.2741C55.1102 55.6901 54.8576 56.068 54.5392 56.3864C54.2209 56.7048 53.8429 56.9573 53.4269 57.1296C53.011 57.3019 52.5651 57.3906 52.1149 57.3906C51.2056 57.3906 50.3335 57.0294 49.6905 56.3864C49.0475 55.7434 48.6863 54.8714 48.6863 53.9621C48.6863 53.0527 49.0475 52.1807 49.6905 51.5377C50.3335 50.8947 51.2056 50.5335 52.1149 50.5335Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4419_239075",
    x: 0.146896,
    y: 0.507736,
    width: 122.909,
    height: 122.909,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 18.2273
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.211765 0 0 0 0 0.713726 0 0 0 0 0.588235 0 0 0 0.75 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4419_239075"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4419_239075",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeropeople);
export default __webpack_public_path__ + "static/media/heropeople.2e265842c9d5be8c7745e997501bbf56.svg";
export { ForwardRef as ReactComponent };